import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import clsx from "classnames";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { MainLayout } from "../components/main-layout/MainLayout";
import {
  ALIAS_KEY,
  ERROR_KEY,
  NO_ALIAS_ERROR,
  UNKNOWN_ALIAS_ERROR,
} from "../components/organization-details-context";

import s from "./HomePage.module.css";

const EnterButton = ({
  organizationAliasHint,
}: {
  organizationAliasHint: string;
}) => {
  const className = "btn btn-primary btn-lg px-4 gap-3";

  if (organizationAliasHint) {
    return (
      <Link
        className={className}
        to={`/${organizationAliasHint}/schedule-week`}
      >
        <AuthenticatedTemplate>Peržvelgti grafiką</AuthenticatedTemplate>
        <UnauthenticatedTemplate>Prisijungti</UnauthenticatedTemplate>
      </Link>
    );
  }

  return (
    <button className={className} disabled={true}>
      <AuthenticatedTemplate>Peržvelgti grafiką</AuthenticatedTemplate>
      <UnauthenticatedTemplate>Prisijungti</UnauthenticatedTemplate>
    </button>
  );
};

const InfoIcon = () => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (tooltipRef.current) {
      new window.bootstrap.Tooltip(tooltipRef.current);
    }
  }, []);

  return (
    <div
      ref={tooltipRef}
      className={s.tooltipTrigger}
      data-bs-title="Tai raktažodis, kurį jūs bei vartotojai naudojate apibūdinti jūsų organizaciją TakeBlock nuorodose."
    >
      i
    </div>
  );
};

const ORGANIZATION_ALIAS_HINT_INPUT_ID = "organizationAliasHint";

export const HomePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [organizationAliasHint, setOrganizationAliasHint] = useState(() => {
    return (
      /https:\/\/admin\.(.+)\.takeblock\.com/.exec(window.location.href)?.[1] ||
      searchParams.get(ALIAS_KEY) ||
      ""
    );
  });
  const [errorMessage, setErrorMessage] = useState(() => {
    const error = searchParams.get(ERROR_KEY);
    switch (error) {
      case NO_ALIAS_ERROR:
        return "Nepasirinktas organizacijos raktažodis.";
      case UNKNOWN_ALIAS_ERROR:
        return "Pateiktas organizacijos raktažodis nerastas.";
      default:
        return "";
    }
  });
  const trimmedOrganizationAliasHint = organizationAliasHint.trim();

  return (
    <MainLayout>
      <div className="px-4 py-5 my-5 text-center">
        <h1 className="display-5 fw-bold">Sveiki atvykę!</h1>
        <div className="col-lg-4 mx-auto">
          <p className="lead mb-4">
            Valdykite klientų rezervacijas bei darbuotojų užimtumą.
          </p>
          <form
            className="gap-2 d-sm-flex flex-column justify-content-sm-center"
            onSubmit={(event) => {
              event.preventDefault();

              if (trimmedOrganizationAliasHint) {
                navigate(`/${organizationAliasHint}/schedule-week`);
              }
            }}
          >
            <div className="mb-3">
              <label
                htmlFor={ORGANIZATION_ALIAS_HINT_INPUT_ID}
                className="form-label"
              >
                Organizacijos raktažodis
                <InfoIcon />
              </label>
              <input
                autoFocus
                type="text"
                name="organizationAliasHint"
                className={clsx("form-control", {
                  "is-invalid": !!errorMessage,
                })}
                id={ORGANIZATION_ALIAS_HINT_INPUT_ID}
                required
                minLength={1}
                maxLength={100}
                defaultValue={trimmedOrganizationAliasHint}
                onChange={({ target: { value } }) => {
                  setOrganizationAliasHint(value);
                  setErrorMessage("");
                }}
              />
              {errorMessage ? (
                <div className="invalid-feedback">{errorMessage}</div>
              ) : null}
            </div>
            <EnterButton organizationAliasHint={trimmedOrganizationAliasHint} />
          </form>
        </div>
      </div>
    </MainLayout>
  );
};
